<ng-container *ngIf="showAlert$ | async; else table">
  <glxy-alert type="warning">
    <strong>
      {{ 'LEAD_INTEGRATIONS.FACEBOOK.FORMS.ERROR_LOADING_TABLE' | translate }}
    </strong>
  </glxy-alert>
</ng-container>

<ng-template #table>
  <va-filtered-mat-table
    [tableDataService]="facebookFormsTableService"
  ></va-filtered-mat-table>
</ng-template>
